import { render, staticRenderFns } from "./DomeEchartWrap.vue?vue&type=template&id=058a0f6a&scoped=true&"
import script from "./DomeEchartWrap.vue?vue&type=script&lang=js&"
export * from "./DomeEchartWrap.vue?vue&type=script&lang=js&"
import style0 from "./DomeEchartWrap.vue?vue&type=style&index=0&id=058a0f6a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058a0f6a",
  null
  
)

export default component.exports